import React, { useState } from 'react';
import api from './api';

const AllReportsButton = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleDownloadAll = async () => {
        setIsLoading(true);
        setError('');

        try {
            const response = await api.get('/reports/export-report', {
                responseType: 'blob',
            });

            // --- SUCCESS PATH ---
            // If we get here, the server responded with a 2xx status code.
            // The data should be the ZIP file blob.
            const disposition = response.headers['content-disposition'];
            let filename = 'AllReports.zip'; // Default filename
            if (disposition) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }

            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (err) {
            // --- ERROR PATH ---
            // This block now handles API errors gracefully.
            if (err.response && err.response.data) {
                // The error response data is a blob. We need to read it as text.
                const errorBlob = err.response.data;
                try {
                    // Blob.text() returns a Promise that resolves with the blob's content as a string.
                    const errorJsonText = await errorBlob.text();
                    const errorData = JSON.parse(errorJsonText);
                    // Now we can display the actual error message from the server.
                    setError(errorData.error || 'An unknown error occurred during download.');
                } catch (parseError) {
                    // Fallback if the error blob isn't valid JSON
                    setError('Failed to parse server error. Download failed.');
                }
            } else {
                // Generic error for network issues, etc.
                setError('Download failed. Check network connection.');
                console.error('Download all reports error:', err);
            }
            // Clear the error message after 5 seconds for better UX.
            setTimeout(() => setError(''), 5000);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
            <button onClick={handleDownloadAll} disabled={isLoading} title="Download a ZIP file with a report for every organisation.">
                {isLoading ? 'Generating...' : '📦 Download All Reports'}
            </button>
            {error && <span style={{ color: 'var(--color-danger)', marginLeft: '10px', fontSize: '12px', fontWeight: 'bold' }}>{error}</span>}
        </div>
    );
};

export default AllReportsButton;
